import { t } from 'services/Translation'

import type { FormErrorMessages } from './types'

export const DEFAULT_FORM_ERROR_MESSAGES: FormErrorMessages = {
  NAME_NOT_UNIQUE: t('input.error.nameExist'),
  LOGIN_NOT_VALID: t('input.error.invalidLogin'),
}
